<div class="bg-white sticky-top">
  <nav class="py-2 bg-warning">
    <div class="container d-flex flex-wrap">
      <ul class="nav ms-auto">
        <li class="nav-item">
          <a
            class="nav-link px-lg-5"
            href="javascript:void(0)"
            (click)="downloadClaimPacket()"
            >File a Claim</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link pe-lg-5" routerLink="/contact">Contact</a>
        </li>
        <li class="nav-item">
          <div class="d-flex align-items-center">
            <span *ngIf="isLoggedIn" class="nav-link mb-0 me-1">{{
              welcomeLabel
            }}</span>
            <a
              *ngIf="!isLoggedIn"
              class="btn btn-outline-light nav-link px-3"
              routerLink="/login"
            >
              Login
            </a>
            <a
              *ngIf="isLoggedIn"
              class="btn btn-outline-light nav-link px-3"
              href="javascript:void(0)"
              (click)="logInOut()"
            >
              Log off
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <nav class="navbar navbar-expand-lg" aria-label="Main DFS Navigation">
    <div class="container d-flex flex-wrap justify-content-center">
      <a
        routerLink="/home"
        class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto"
      >
        <img
          src="assets/images/dfs-ins-logo-dark.svg"
          width="152"
          height="72"
          alt="DFS Insurance"
        />
      </a>
      <button
        class="ms-auto navbar-toggler border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#primaryNav"
        aria-controls="primaryNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="primaryNav">
        <ul
          class="navbar-nav nav ms-auto align-items-end align-items-lg-center"
        >
          <li class="nav-item">
            <a
              routerLink="/irrigation-insurance"
              class="nav-link link-dark px-4"
              >Irrigation Insurance</a
            >
          </li>
          <li class="nav-item">
            <a routerLink="/forms" class="nav-link link-dark px-4">Forms</a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link link-dark px-4 dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >Agents</a
            >
            <ul class="dropdown-menu">
              <li *ngIf="!isLoggedIn">
                <a class="dropdown-item" routerLink="/login">Agent Login</a>
              </li>
              <li *ngIf="isLoggedIn">
                <a class="dropdown-item" routerLink="/agent/dashboard"
                  >Agent Dashboard</a
                >
              </li>
              <li *ngIf="!isLoggedIn">
                <a class="dropdown-item" routerLink="/register"
                  >Agent Registration</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link link-dark px-4 dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >About Us</a
            >
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" routerLink="/about">About DFS</a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="https://www.fnbo.com/careers"
                  target="_blank"
                  >Careers</a
                >
              </li>
              <li>
                <a class="dropdown-item" routerLink="/contact">Contact Us</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
